export default __webpack_public_path__ + "static/media/093-resize-1.a4dff7b4.png";